import React from 'react';
import { Tabs, Tab, } from '@heroui/react';
import { Radio, RadioGroup } from '@atoms/new/RadioGroup';

import {

  StarBorder, SentimentVerySatisfied, Grade
} from '@mui/icons-material';

import { SelectItem, Select } from '@atoms/new/select';

import SettingBlock from '@components/Presentation/main/Settings/units/SettingBlock';

import { EMOJI_ICONS } from '@components/Presentation/main/Settings/RatingPollsSettings';
import TextLimiterInput from '@molecules/TextLimiterInput';

const RatingPollsOptions = ({
  options,
  updateSetting,
  setting,
  updateBulkOptions

}: any) => {
  React.useEffect(() => {
    if (setting?.ratingPollScale && setting.ratingPollScale !== '5') {
      updateBulkOptions(parseInt(setting.ratingPollScale.toString()));
    }
  }, []);

  return (
    <>
      <SettingBlock
        title="Scale adjustment"
        addPadding= {false}
        titleMargin="sm"
      >
        <div className='flex justify-between items-center'>
          <p className='text-sm font-medium'>Choose a rating scale</p>
          <div className='w-1/3'>
            <Select selectedKeys={new Set([setting?.ratingPollScale?.toString() || '5'])} onSelectionChange={(key) => {
              if (!key.currentKey) return;
              updateSetting('ratingPollScale', key.currentKey);
              updateBulkOptions(parseInt(key.currentKey));
            }}>
              <SelectItem key={5}>5</SelectItem>
              <SelectItem key={10}>10</SelectItem>
            </Select>
          </div>

        </div>
      </SettingBlock>

      <SettingBlock
        addPadding= {false}
        titleMargin='sm'

      >
        <div className=' '>
          <Tabs
            size='lg'
            classNames={{
              tabList: 'bg-grey-100 dark:bg-grey-800 rounded-lg p-0.5',
              tabContent: 'text-sm font-semibold group-data-[selected=true]:text-primary-500 ',
              cursor: 'shadow-none rounded-md',

            }}

            selectedKey={setting?.scoreLabelType}
            className="self-center "

            onSelectionChange={(key) => {
              updateSetting('scoreLabelType', key);
            }}
          >

            <Tab key="LABELS" title="Labels">
              <div className='mt-6 flex  gap-2 items-center justify-between'>
                <p className='text-sm font-normal'>Label (for 1)</p>
                <div className='w-1/2'>
                  <TextLimiterInput
                    defaultValue={'Not great'}
                    value={setting?.lowScoreLabel}
                    setValue={(value) => updateSetting('lowScoreLabel', value)}
                    limit={50}
                    placeholder='Enter label' />
                </div>
              </div>
              <div className='mt-6 flex  gap-2 items-center justify-between'>
                <p className='text-sm font-normal'>Label (for {setting?.ratingPollScale || '5'})</p>
                <div className='w-1/2'>
                  <TextLimiterInput defaultValue={'Great'}
                    value={setting?.highScoreLabel}
                    setValue={(value) => updateSetting('highScoreLabel', value)}
                    limit={50}
                    placeholder='Enter label' />

                </div>
              </div>
            </Tab>
            <Tab key="ICONS" title="Icons">
              <div className="mt-6">

                <RadioGroup value={setting?.iconType} defaultSelectedKeys={['STAR']} orientation='horizontal' onChange={(key: 'STAR' | 'EMOJI') => updateSetting('iconType', key)}>
                  <Radio key='STAR' value='STAR' >
                    <StarBorder className={setting?.iconType === 'STAR' ? 'text-primary-500' : 'text-gray-400'} />
                  </Radio>
                  <Radio key='EMOJI' value='EMOJI'>
                    <SentimentVerySatisfied className={setting?.iconType === 'EMOJI' ? 'text-primary-500' : 'text-gray-400'} />
                  </Radio>
                </RadioGroup>
              </div>
              {setting.iconType === 'STAR' ?
                <div className='mt-6 flex   items-center justify-between'>
                  {Array.from({ length: parseInt(setting.ratingPollScale || '1') }).map((_, index) => (
                    <Grade key={`star-${index}`} className='text-yellow-600' />
                  ))}

                </div>
                : null}

              {setting.iconType === 'EMOJI' ?
                <div className='mt-6 flex   items-center justify-between'>
                  {Array.from({ length: parseInt(setting.ratingPollScale || '1') }).map((_, index) => {
                    const scale = setting.ratingPollScale as '5' | '10';
                    return (
                      <span key={`emoji-${index}`}>{EMOJI_ICONS[scale][(index + 1) as keyof typeof EMOJI_ICONS[typeof scale]]}</span>
                    );
                  })}
                </div>
                : null}
            </Tab>
          </Tabs>

        </div>
      </SettingBlock>
    </>
  );
};

export default RatingPollsOptions;
